import { openEventChannel } from './openEventChannel';
import { ERequestApiStatus } from '../../types/appState';
import { TThunkAction } from '../../types/redux/thunk';

let ensureEventChannelOpenPromise: Promise<boolean> | null = null;

export const resetEnsureEventChannelOpenForTests = () => {
  ensureEventChannelOpenPromise = null;
};

/**
 * Восстанавливает WS-соединение, если канал закрыт или socketStatus === Failed.
 * Параллельные вызовы разделяют один in-flight reconnect.
 */
export const ensureEventChannelOpen =
  (): TThunkAction<Promise<boolean>> =>
  async (dispatch, getState, { custom: { socket } }) => {
    if (!socket?.eventChannel) {
      return false;
    }

    const { eventChannel } = socket;
    const { socketStatus } = getState();

    const isClosed = eventChannel.isChannelClosed() || socketStatus === ERequestApiStatus.Failed;

    if (!isClosed) {
      return true;
    }

    if (ensureEventChannelOpenPromise) {
      return ensureEventChannelOpenPromise;
    }

    ensureEventChannelOpenPromise = dispatch(openEventChannel(true))
      .then(() => getState().socketStatus === ERequestApiStatus.Succeed)
      .finally(() => {
        ensureEventChannelOpenPromise = null;
      });

    return ensureEventChannelOpenPromise;
  };
